import { Field, NumericInput, TextOutput } from 'Components/Core';
import {
  WorksheetBatchUpdateEquipmentDisplayField,
  WorksheetBatchUpdateEquipmentSelectionField,
} from 'Components/WorksheetBatchUpdate/Core/SpecialisedFieldComponents';
import { WorksheetBatchUpdateWorksheetFieldSection } from 'Components/WorksheetBatchUpdate/types';
import { WorksheetBatchUpdateWorksheetField } from '../..';

export const AsNuclearFieldDensityWorksheetSections: {
  [name: string]: WorksheetBatchUpdateWorksheetFieldSection;
} = {
  preparation: {
    heading: 'Preparation',
  },
  measurements: {
    heading: 'Measurements',
  },
};

export const AsNuclearFieldDensityWorksheetFields: {
  [name: string]: WorksheetBatchUpdateWorksheetField;
} = {
  'data.Preparation.LayerDepth': {
    displayComponent: <Field input={<TextOutput />} />,
    entryComponent: <Field input={<NumericInput />} />,
    section: 'preparation',
  },
  'data.Preparation.NuclearDensityGauge': {
    displayComponent: <WorksheetBatchUpdateEquipmentDisplayField />,
    entryComponent: <WorksheetBatchUpdateEquipmentSelectionField equipmentType="nuclear-density-gauge" />,
    displayFieldsWhenEntered: ['data.Preparation.NuclearDensityGaugeMakeAndModel'],
    isImportSource: true,
    equipmentDetails: {
      calibrationImportMismatchField: 'data.Preparation.NuclearDensityGaugeCalibratedImportMismatch',
      propertiesImportMismatchField: 'data.Preparation.NuclearDensityGaugePropertiesImportMismatch',
    },
    section: 'preparation',
  },
  'data.Preparation.NuclearDensityGaugeMakeAndModel': {
    displayComponent: <Field input={<TextOutput />} />,
  },
  'data.Preparation.DensityStandardCount': {
    entryComponent: <Field input={<NumericInput />} />,
    displayComponent: <Field input={<TextOutput />} />,
    displayFieldsWhenEntered: [
      'data.Measurements.Readings[0].DensityCountRatio',
      'data.Results.InsituWetDensity',
      'data.Results.InsituDryDensity',
    ],
    section: 'preparation',
  },
  'data.Preparation.MoistureStandardCount': {
    entryComponent: <Field input={<NumericInput />} />,
    displayComponent: <Field input={<TextOutput />} />,
    displayFieldsWhenEntered: [
      'data.Measurements.Readings[0].MoistureCountRatio',
      'data.Results.InsituWetDensity',
      'data.Results.InsituDryDensity',
    ],
    section: 'preparation',
  },
  'data.Measurements.Depth': {
    entryComponent: <Field input={<NumericInput />} />,
    displayComponent: <Field input={<TextOutput />} />,
    section: 'measurements',
  },
  'data.Measurements.Readings[0].DensityCountRatio': {
    displayComponent: <Field input={<TextOutput />} />,
    section: 'measurements',
  },
  'data.Measurements.Readings[0].MoistureCountRatio': {
    displayComponent: <Field input={<TextOutput />} />,
    section: 'measurements',
  },
  'data.Results.InsituWetDensity': {
    displayComponent: <Field input={<TextOutput />} />,
    section: 'measurements',
  },
  'data.Results.InsituDryDensity': {
    displayComponent: <Field input={<TextOutput />} />,
    section: 'measurements',
  },
};

export default AsNuclearFieldDensityWorksheetFields;
